module.exports = __webpack_public_path__ + "img/section12.bc162b48.png";